// Кнопки ответа прямо в пуше. Пуш приходит с `categoryId`, а приложение заранее
// регистрирует, какие кнопки у этой категории. Старые версии без регистрации
// просто покажут пуш без кнопок. Бэкенд и мобилка берут строки отсюда — они
// обязаны совпадать.

export const PUSH_ACTION = {
  voteYes: 'vote_yes',
  voteMaybe: 'vote_maybe',
  voteNo: 'vote_no',
  inviteAccept: 'invite_accept',
  inviteDecline: 'invite_decline',
} as const;

export type PushActionId = (typeof PUSH_ACTION)[keyof typeof PUSH_ACTION];

export const PUSH_ACTION_CATEGORY = {
  gameAnnounced: 'game_announced',
  gameInvite: 'game_invite',
} as const;

const CATEGORY_BY_TYPE: Record<string, string> = {
  game_announced: PUSH_ACTION_CATEGORY.gameAnnounced,
  game_invite: PUSH_ACTION_CATEGORY.gameInvite,
};

/** Категория с кнопками для типа уведомления; undefined — пуш без кнопок. */
export function pushCategoryFor(type: string): string | undefined {
  return CATEGORY_BY_TYPE[type];
}
